import { EmailShareButton } from 'react-share';
import { FC } from 'react';
import { Box, Center, Text, VStack } from '@chakra-ui/react';
import { Email } from '../../assets';
import { getDataTracking } from '../../utils';
import { TrackingLabelProps } from '../../types/global';

export interface EmailShareProps extends TrackingLabelProps {
  url?: string;
  subject?: string;
  separator?: string;
  hasSupportText?: boolean;
}

export const EmailShare: FC<EmailShareProps> = ({
  url,
  subject,
  separator,
  hasSupportText = true,
  trackingLabel,
}) => (
  <EmailShareButton
    url={url as string}
    subject={subject}
    separator={separator}
    {...getDataTracking(`${trackingLabel}Email`)}
  >
    <Center w="140px" h="126px">
      <VStack>
        <Email boxSize="64px" />
        {hasSupportText && (
          <Box mt={2}>
            <Text fontSize="md">Email</Text>
          </Box>
        )}
      </VStack>
    </Center>
  </EmailShareButton>
);
